var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronForward(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 12,
    viewBox: "0 0 7 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.175 5.99688L0.275 2.09688C0.0916667 1.91354 0 1.68021 0 1.39688C0 1.11354 0.0916667 0.880208 0.275 0.696875C0.458333 0.513542 0.691667 0.421875 0.975 0.421875C1.25833 0.421875 1.49167 0.513542 1.675 0.696875L6.275 5.29688C6.375 5.39687 6.44583 5.50521 6.4875 5.62188C6.52917 5.73854 6.55 5.86354 6.55 5.99688C6.55 6.13021 6.52917 6.25521 6.4875 6.37188C6.44583 6.48854 6.375 6.59688 6.275 6.69688L1.675 11.2969C1.49167 11.4802 1.25833 11.5719 0.975 11.5719C0.691667 11.5719 0.458333 11.4802 0.275 11.2969C0.0916667 11.1135 0 10.8802 0 10.5969C0 10.3135 0.0916667 10.0802 0.275 9.89688L4.175 5.99688Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronForward);
export default __webpack_public_path__ + "static/media/chevron_forward.cc33d57e6d05225b8b6f8065df847504.svg";
export { ForwardRef as ReactComponent };